import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'safe-area-header',
  templateUrl: './safe-area-header.component.html',
  styleUrls: ['./safe-area-header.component.scss'],
})
export class SafeAreaHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
